import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import LanguageToggle from '../components/LanguageToggle';
import { useLanguage } from '../context/LanguageContext';
import styles from './PolicyPage.module.css';
import Navbar from '../components/Navbar';

const RefundPolicy = () => {
  const { t } = useLanguage();

  return (
    <div className={styles.page}>
      {/* Navbar */}
      <Navbar commonNavigation className={styles.navbar} innerClassName={styles.navInner} brandClassName={styles.navBrand} brand="ReplyShoot">
          <div className={styles.navLinks}>
            <Link to="/" className={styles.navLink}>{t('home', 'Home')}</Link>
            <Link to="/tools" className={styles.navLink}>{t('tools', 'Tools')}</Link>
            <LanguageToggle />
            <Link to="/onboarding" className={styles.navBtn}>{t('getStarted', 'Get Started')}</Link>
          </div>
      </Navbar>

      {/* Hero */}
      <header className={styles.hero}>
        <h1 className={styles.heroTitle}>{t('refundPolicy', 'Refund Policy')}</h1>
        <p className={styles.heroSub}>
          {t('refundSub', 'Clear guidelines on refund conditions, rules, and calculation methods.')}
        </p>
      </header>

      {/* Content */}
      <main className={styles.content}>
        <article>
          <p>{t('refundP1', 'This Refund Policy explains how refunds are handled for monthly and annual subscriptions to ReplyShoot. It is intended to provide clear expectations and examples for eligible refund requests.')}</p>

          <h2>{t('monthlySubsTitle', 'Monthly Subscriptions')}</h2>
          <p>{t('monthlySubsSub', 'Monthly subscriptions are evaluated based on the billing cycle and the date the refund request is submitted.')}</p>
          <ul>
            <li><strong>{t('firstHalfTitle', 'First half of the month:')}</strong> {t('firstHalfDesc', 'Refund requests submitted during the first half of the billing month are eligible for a refund equal to 50% of the current month’s fee.')}</li>
            <li><strong>{t('secondHalfTitle', 'Second half of the month:')}</strong> {t('secondHalfDesc', 'Requests submitted during the second half of the billing month are not eligible for a refund of the current month’s fee.')}</li>
          </ul>
          <div className={styles.callout}>
            <p><strong>{t('exampleLabel', 'Example:')}</strong> {t('monthlyExample', 'If your billing period begins on the 1st and you request a refund on the 10th, you may receive a 50% refund for that month. If the request is made on the 20th, the current month is considered fully earned.')}</p>
          </div>

          <h2>{t('annualSubsTitle', 'Annual Subscriptions')}</h2>
          <p>{t('annualSubsSub', 'Annual subscriptions use the same monthly half-cycle rule for the current month, plus a refund for any remaining unused full months.')}</p>
          <ol>
            <li>{t('annualRule1', 'If the refund request is submitted in the first half of the current month, 50% of the current month’s charge is refundable.')}</li>
            <li>{t('annualRule2', 'If the request is submitted in the second half, the current month is non-refundable.')}</li>
            <li>{t('annualRule3', 'The remaining unused full months of the annual term are refunded at the equivalent monthly rate.')}</li>
          </ol>
          <div className={styles.callout}>
            <p><strong>{t('exampleLabel', 'Example:')}</strong> {t('annualExample', 'If your annual billing date is January 5 and you request a refund on March 8, you may receive 50% of March plus refunds for the unused months of April through December. If you request a refund on March 20, you would be eligible only for remaining full months.')}</p>
          </div>

          <h2>{t('processingTitle', 'Processing')}</h2>
          <p>{t('processingDesc', 'Refunds are issued to the payment method used for purchase. Processing times vary by payment provider and may take several business days.')}</p>

          <h2>{t('cancellationAccessTitle', 'Cancellation and Access')}</h2>
          <p>{t('cancellationAccessDesc', 'When a refund is approved, your subscription may remain active through the end of the paid period unless stated otherwise in your account notification.')}</p>

          <h2>{t('refundUpdatesTitle', 'Policy Updates')}</h2>
          <p>{t('refundUpdatesDesc', 'ReplyShoot may change this Refund Policy at any time. Updated policies will be posted on our website and apply to future purchases and refund requests.')}</p>
        </article>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default RefundPolicy;
